/* global globalThis */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuthorization from "../../hooks/useAuthorization";

// v6 guard: renders its children (the auth screen) when logged out, else
// redirects to /dashboard. Keeps the per-route document.title + spacing class.
export const PublicRoute = ({ children, title }) => {
  const { validateToken } = useAuthorization();
  const isValid = validateToken(localStorage.getItem("token"));
  const pathname = globalThis.location.pathname;
  const isPasswordRoute =
    pathname === "/login" ||
    pathname === "/change-password" ||
    pathname === "/forgot-password";
  const routeClassName = `main-div ${isPasswordRoute ? "mobile-view-password-spacing" : ""}`;

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return isValid ? (
    <Navigate to="/dashboard" replace />
  ) : (
    <div className={routeClassName}>{children}</div>
  );
};

PublicRoute.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};
